var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformationCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88672 8.49855C1.88672 4.77143 4.90815 1.75 8.63527 1.75C12.3624 1.75 15.3838 4.77143 15.3838 8.49855C15.3838 12.2257 12.3624 15.2471 8.63527 15.2471C4.90815 15.2471 1.88672 12.2257 1.88672 8.49855ZM8.63538 5C8.22116 5 7.88538 5.33579 7.88538 5.75V5.755C7.88538 6.16921 8.22116 6.505 8.63538 6.505H8.64037C9.05459 6.505 9.39037 6.16921 9.39037 5.755V5.75C9.39037 5.33579 9.05459 5 8.64037 5H8.63538ZM7.46468 8.33395C7.58244 8.56948 7.80742 8.71596 8.05088 8.74384L7.67149 10.2614C7.4125 11.2973 8.48791 12.16 9.44301 11.6825L9.44304 11.6824L9.47069 11.6686C9.84117 11.4834 9.99132 11.0329 9.80607 10.6624C9.6883 10.4269 9.46333 10.2804 9.21987 10.2525L9.59926 8.73496C9.85825 7.699 8.78284 6.83634 7.82774 7.31389L7.82774 7.31389L7.80008 7.32772C7.4296 7.51296 7.27944 7.96347 7.46468 8.33395Z",
    fill: "#257DE7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/information-circle.8df74c5a4d49ad49889e6d7dbee69880.svg";
export { ForwardRef as ReactComponent };